const ambassadorsReducer = (state = {
  page: 0,
  ambassadors: [],
}, action) => {
  switch (action.type) {
    case 'GET_AMBASSADORS':
      return {
        ...state,
        ...action.ambassadors,
      };
    case 'GET_AMBASSADOR':
      return {
        ...state,
        activeAmbassador: { ...action.activeAmbassador },
        tiles: [...action.tiles],
      };
    default:
      return { ...state };
  }
};

export default ambassadorsReducer;



// WEBPACK FOOTER //
// ./frontend/js/Base/Reducers/ambassadorsReducer.jsx